import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';

/**
 *
 * @param param0
 * @returns {운영-코인환전관리 테이블}
 */

interface IProps {
  children: JSX.Element[] | JSX.Element;
}

const ExchangeTable: React.FC<IProps> = ({ children }) => {
  return <StyledTable>{children}</StyledTable>;
};

export default ExchangeTable;

const StyledTable = styled.table`
  width: 100%;
  tbody {
    width: inherit;
    tr {
      th {
        vertical-align: middle;
        color: ${theme.colors.blueText};
        font-weight: 700;
        text-align: right;
        padding-right: 0.5rem;
      }

      td {
        height: 4rem;
        > span {
          margin-left: 0.5rem;
        }
      }
      .th_number {
        font-weight: 700;
        font-size: 1rem;
        color: ${theme.colors.black};
      }
      .td_icon {
        text-align: left;
        width: 3%;
      }
      .td_none {
        width: 1%;
      }
    }
  }
`;
